/**
 * GTS 영상 삭제 API
 * JSON (contentData.videos)과 S3에서 영상을 삭제합니다
 */
import { axiosClient } from '@/shared/apis/config';
import { ApiResponse } from '@/shared/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeyGetGtsVideos } from './get-gts-videos';

export type DeleteGtsVideoResponse = ApiResponse<boolean>;

/**
 * 영상 삭제 요청
 */
export const deleteGtsVideoApi = async (
  projectId: number,
  videoId: string,
): Promise<DeleteGtsVideoResponse> => {
  try {
    const response = await axiosClient.delete<DeleteGtsVideoResponse>(
      `/v1.0/project/${projectId}/gts/video/${videoId}`,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useDeleteGtsVideo = (projectId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (videoId: string) => deleteGtsVideoApi(projectId, videoId),
    onSuccess: () => {
      // 영상 목록 갱신
      queryClient.invalidateQueries({
        queryKey: [QueryKeyGetGtsVideos, projectId],
      });
      // GTS 상태도 함께 갱신
      queryClient.invalidateQueries({
        queryKey: ['getGtsState', projectId],
      });
    },
  });
};
